import './assets/css/main.less'
import Vue from 'vue'
import App from './App.vue'
import router from "./router/index.js";
import store from "./store";
import VueI18n from 'vue-i18n';
import http from './http/index.js'
import utils from './utils/utils.js'
import './utils/flexible'
import './utils/vant.js' // 按需自动导入 vant 组件
import './utils/devTool.js'

window.onload = function () {
  // 禁止 ios 中双击、双指缩放页面
  document.addEventListener('gesturestart', function (event) {
    event.preventDefault();
  });
}

Vue.use(VueI18n);
Vue.config.productionTip = false
Vue.prototype.$http = http
Vue.prototype.$utils = utils
// 格式化金额
Vue.filter("formatAmount", (amount) => utils.formatAmount(amount))

// 设置初始语言
let initLang = localStorage.getItem("lang")
let langList = ['de-de', 'en-us', 'es-mx', 'fil', 'fr-fr', 'ja-jp', 'pt-pt', 'zh-cn',]
if (!initLang || !langList.includes(initLang)) {
  initLang = "es-mx"
  localStorage.setItem("lang", initLang)
}
// 导入语言包
const i18n = new VueI18n({
  globalInjection: true,
  locale: initLang, // 将要切换的语言，可以通过url拼的参数获取，用户行为select选择获取，本地manifest配置获取等，根据场景动态获取
  messages: {
    'de-de': require('./assets/lang/de_de.json'), // 德语
    'en-us': require('./assets/lang/en_us.json'), // 英语
    'es-mx': require('./assets/lang/es_mx.json'), // 西班牙语
    'fil': require('./assets/lang/fil.json'), // 菲律宾语
    'fr-fr': require('./assets/lang/fr_fr.json'), // 法语
    'ja-jp': require('./assets/lang/ja_jp.json'), // 日语
    'pt-pt': require('./assets/lang/pt_pt.json'), // 葡萄牙语
    'zh-cn': require('./assets/lang/zh_cn.json'), // 简体中文
  }
});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app')
